import styled from 'styled-components';

export const StyledContainer = styled.div`
	background: ${({ theme }) => theme.background};
	padding: 1rem 2rem;
	height: 100vh;
	bottom: 0;
`;
